var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errored
      ? _c("section", { staticClass: "overlay" }, [_vm._m(0)])
      : _c(
          "section",
          [
            _vm.loading
              ? _c("div", { staticClass: "overlay" }, [
                  _c("p", { staticClass: "overlay-text loading-text" }, [
                    _vm._v("Loading...")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "loading-spacer" },
                    [
                      _c("vue-loading", {
                        attrs: {
                          type: "spiningDubbles",
                          color: "#FFF",
                          size: { width: "100px", height: "100px" }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Header"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "home-body" },
              [
                _c(
                  "div",
                  { staticClass: "user-information" },
                  [
                    _c("UserInformation", {
                      on: { "handle-loading": _vm.isLoading }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "meal-record" }, [
                  _c("img", {
                    staticClass: "frame",
                    attrs: { src: require("@/assets/home/アセット 33@2x.png") }
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "today-date" }, [
                    _vm._v(_vm._s(_vm.todayDate) + "の食事記録")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "achievement-contents" }, [
                    _c("div", { staticClass: "crown-img staple-food-crown" }, [
                      _vm.stapleFoodCrown
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 27@2x.png")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "crown-img side-dish-crown" }, [
                      _vm.sideDishCrown
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 27@2x.png")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "crown-img water-crown" }, [
                      _vm.waterCrown
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 27@2x.png")
                            }
                          })
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "alert-contents" }, [
                    _c("div", { staticClass: "alert-img staple-food-alert" }, [
                      _vm.stapleFoodAlert
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 26@2x.png")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "alert-img side-dish-alert" }, [
                      _vm.sideDishAlert
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 26@2x.png")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "alert-img water-alert" }, [
                      _vm.waterAlert
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/home/アセット 26@2x.png")
                            }
                          })
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "meal-result-content" }, [
                    _c("div", { staticClass: "daily-meal-result" }, [
                      _c(
                        "div",
                        {
                          staticClass: "facial-expression-mark",
                          on: { click: _vm.mealHistory }
                        },
                        [
                          _vm.stapleFoodCrown
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/home/アセット 23@2x.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.stapleFoodCrown
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/home/アセット 30@2x.png")
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "foods-graph-doughnut",
                          on: { click: _vm.mealHistory }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "side-foods-score",
                              style: { color: _vm.sideDishChartColor }
                            },
                            [_vm._v(_vm._s(_vm.foodsIngestedTodayScore))]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "side-foods-score-text" }, [
                            _vm._v("食品群")
                          ]),
                          _vm._v(" "),
                          _vm.showFoodsGraphDoughnut
                            ? _c("FoodsGraphDoughnut", {
                                attrs: {
                                  "chart-data": _vm.foodsDatacollection,
                                  options: _vm.foodsOptions
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "water-graph-doughnut",
                          on: { click: _vm.waterHistory }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "water-amount-score",
                              style: { color: _vm.waterChartColor }
                            },
                            [_vm._v(_vm._s(_vm.foodsIngestedTodayWater))]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "water-amount-score-text" }, [
                            _vm._v("ml")
                          ]),
                          _vm._v(" "),
                          _vm.showWaterGraphDoughnut
                            ? _c("WaterGraphDoughnut", {
                                attrs: {
                                  "chart-data": _vm.waterDatacollection,
                                  options: _vm.waterOptions
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/recordMeals" } }, [
                  _c("div", { staticClass: "record-meals" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/home/アセット 100@2x.png/"),
                        width: "1600",
                        height: "378",
                        loding: "lazy"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cooperation" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "frame",
                    attrs: { src: require("@/assets/home/アセット 28@2x.png") }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "mark",
                    attrs: { src: require("@/assets/home/アセット 21@2x.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { on: { click: _vm.openModal } }, [
                    _c("img", {
                      staticClass: "link-button",
                      attrs: {
                        src: require("@/assets/home/アセット 22@2x.png")
                      }
                    })
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("Footer"),
            _vm._v(" "),
            _vm.isTutorial ? _c("Tutorial") : _vm._e(),
            _vm._v(" "),
            _vm.showNotIngestedAlert
              ? _c("NotIngestedAlert", {
                  attrs: { notIngestedFoods: _vm.notIngestedFoods },
                  on: { "handle-hide-dialog": _vm.closeNotIngestedAlert }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showContent
              ? _c("ShowContent", {
                  on: { "handle-hide-content": _vm.closeModal }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "overlay-text" }, [
      _vm._v("申し訳ありませんが、"),
      _c("br"),
      _vm._v("現時点ではこの情報を取得できません。"),
      _c("br"),
      _vm._v("しばらくしてからもう一度お試しください")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "today-img" }, [
      _c("img", { attrs: { src: require("@/assets/home/アセット 29@2x.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lashic-log" }, [
      _c("img", { attrs: { src: require("@/assets/home/アセット 34@2x.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a90ec03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90ec03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = null
// module chunks = 